/**
 * Relieve: tilfoej ekstra maske direkte i cart drawer uden reload.
 *
 * Horizon's CartItemsComponent lytter paa document efter
 * StandardEvents.cartLinesUpdate. Vi dispatcher praecis samme event med en
 * deferred promise, saa komponenten selv morpher sektionen ind - drawer'en
 * bliver aaben, totalen, rabatten og "Gaa til betaling" opdateres i samme
 * bevaegelse.
 */
import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.__rlvCupBound) {
  window.__rlvCupBound = true;

  document.addEventListener('click', async (event) => {
    const target = event.target;
    const btn = target && target.closest ? target.closest('[data-rlv-add]') : null;
    if (!btn) return;

    event.preventDefault();
    if (btn.dataset.rlvBusy === '1') return;

    const variantId = Number(btn.getAttribute('data-rlv-add'));
    if (!variantId) return;

    const originalLabel = btn.textContent;
    btn.dataset.rlvBusy = '1';
    btn.disabled = true;
    btn.textContent = 'Tilføjer…';

    // Alle cart-sektioner i DOM'en skal med, saa baade drawer og en evt.
    // aaben kurv-side opdateres i samme svar.
    const sectionIds = new Set(['cart-drawer-section']);
    for (const el of document.querySelectorAll('cart-items-component[data-section-id]')) {
      if (el.dataset.sectionId) sectionIds.add(el.dataset.sectionId);
    }

    const deferred = CartLinesUpdateEvent.createPromise();

    btn.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'cart',
        lines: [{ id: String(variantId), quantity: 1 }],
        promise: deferred.promise,
      })
    );

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: Array.from(sectionIds).join(','),
          sections_url: window.location.pathname,
        }),
      });

      const data = await response.json();
      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Kunne ikke tilfoeje varen.');
      }

      let itemCount = 0;
      const drawerHtml = data.sections && data.sections['cart-drawer-section'];
      if (drawerHtml) {
        const parsed = new DOMParser().parseFromString(drawerHtml, 'text/html');
        const raw = parsed.querySelector('[ref="cartItemCount"]');
        itemCount = raw ? parseInt(raw.textContent || '0', 10) || 0 : 0;
      }

      let cart = null;
      try {
        cart = CartLinesUpdateEvent.createCartFromAjaxResponse(data);
      } catch (err) {
        cart = null;
      }

      deferred.resolve({
        cart,
        detail: {
          sections: data.sections,
          items: data.items,
          itemCount,
          source: 'relieve-cart-upsell',
          didError: false,
        },
      });

      // Drawer'en skal blive aaben og synlig - ingen navigation, ingen reload.
      const drawer = document.querySelector('theme-drawer#cart-drawer');
      if (drawer && typeof drawer.open === 'function' && drawer.isOpen === false) {
        drawer.open();
      }
    } catch (error) {
      deferred.reject(error);
      btn.dataset.rlvBusy = '0';
      btn.disabled = false;
      btn.textContent = originalLabel;
    }
  });

  // Farvevalg direkte i kurven: skifter hvilken variant knappen tilfoejer.
  document.addEventListener('click', (event) => {
    const target = event.target;
    const chip = target && target.closest ? target.closest('[data-rlv-variant]') : null;
    if (!chip) return;

    event.preventDefault();
    const cup = chip.closest('[data-rlv-cup]');
    if (!cup) return;

    for (const other of cup.querySelectorAll('[data-rlv-variant]')) {
      other.classList.remove('is-on');
      other.setAttribute('aria-checked', 'false');
    }
    chip.classList.add('is-on');
    chip.setAttribute('aria-checked', 'true');

    const addBtn = cup.querySelector('[data-rlv-add]');
    if (addBtn) addBtn.setAttribute('data-rlv-add', chip.getAttribute('data-rlv-variant'));

    const title = cup.querySelector('[data-rlv-cup-title]');
    if (title) title.textContent = chip.getAttribute('data-rlv-title') || '';

    const img = cup.querySelector('[data-rlv-cup-img]');
    const src = chip.getAttribute('data-rlv-img');
    if (img && src) {
      img.src = src;
      img.alt = chip.getAttribute('data-rlv-title') || '';
    }
  });
}
